export let wordIdToWord = {}

export function initWordIdToWord(words) {
    wordIdToWord = words.reduce((map, word) => {
        map[word.id] = word
        return map
    }, {})
}